export const Select = (props) => {
    const { option, text, start, stop, step, onChange } = props;

    const range = (start, stop, step) => Array.from({length: (stop - start) / step + 1}, (_, i) => start + (i * step));

    function setOption(array) {
        let list = [];
        list.push(<option value={""} key="">{""}</option>)
        array.forEach((element, index) => {
            list.push(<option value={element} key={index}>{element}</option>)
        });

        return list;
    }

    return (
        <>
            <select className="border border-grey" onChange={onChange}>
                {setOption(range(start, stop, step))}
            </select>
            {text}
        </>
    );
}